import { render, staticRenderFns } from "./ActionItemDialog.vue?vue&type=template&id=27b9507f&"
import script from "./ActionItemDialog.vue?vue&type=script&lang=js&"
export * from "./ActionItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActionItemDialog.vue?vue&type=style&index=0&id=27b9507f&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b9507f')) {
      api.createRecord('27b9507f', component.options)
    } else {
      api.reload('27b9507f', component.options)
    }
    module.hot.accept("./ActionItemDialog.vue?vue&type=template&id=27b9507f&", function () {
      api.rerender('27b9507f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/actionsDictionary/actionItemDialog/ActionItemDialog.vue"
export default component.exports